import { WithPlanBadge } from '@/shared/components/Badge/PlanBadge';
import { useUpsellingGuard, useUserPlanManager } from '@/shared/plan';
import { type ButtonProps } from '@/ui_v3';
import { EditTools } from '../../EditTools';
import { useAiSingleChoiceGeneration } from './useAiSingleChoiceGeneration';
export const AiSingleChoiceGenerationButton = ({
  choiceIndex,
  ...buttonProps
}: {
  choiceIndex: number;
} & Omit<ButtonProps, 'onClick' | 'asChild'>) => {
  const {
    generate,
    disabled
  } = useAiSingleChoiceGeneration(choiceIndex);
  const {
    userPlanManager
  } = useUserPlanManager();
  const upsellingGuard = useUpsellingGuard();
  const featurePlanType = userPlanManager.getFeaturePlanType('AI_CHOICE_GENERATION');
  return <WithPlanBadge planType={featurePlanType} isBadgeVisible={true} data-sentry-element="WithPlanBadge" data-sentry-component="AiSingleChoiceGenerationButton" data-sentry-source-file="AiSingleChoiceGenerationButton.tsx">
      <EditTools.AiAnswerGenerationButton {...buttonProps} disabled={disabled} onClick={() => {
      void upsellingGuard(generate, {
        feature: 'AI_CHOICE_GENERATION',
        from: 'ai'
      });
    }} data-sentry-element="unknown" data-sentry-source-file="AiSingleChoiceGenerationButton.tsx" />
    </WithPlanBadge>;
};